import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import { Group, Title } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import InformationTooltipIcon from '../../UI/InformationTooltipIcon/InformationTooltipIcon';

export const PriceLine = ( {
	cost, costDescription, tooltipInfoText
} ) => (

	<Group className="PriceLine" spacing="4px">
		<Title order={3}>${cost}</Title>
		<Text variant="body">{costDescription}</Text>
		{tooltipInfoText && (
			<InformationTooltipIcon
				html={(
					<div style={{ width: '280px', textAlign: 'center' }}>
						{tooltipInfoText}
					</div>
				)}
			/>
		)}
	</Group>

);

PriceLine.propTypes = {
	cost: PropTypes.number.isRequired,
	costDescription: PropTypes.string.isRequired,
	tooltipInfoText: PropTypes.string
};

PriceLine.defaultProps = {
	tooltipInfoText: undefined
};

export default observer( PriceLine );
